import { z } from 'zod';

export const clientSchema = z.object({
  name: z.string().min(1, 'Point of Contact is required'),
  businessName: z.string().min(1, 'Client name is required'),
  email: z.string().email('Please enter a valid email'),
  phoneNumber: z.object({
    countryCode: z.string(),
    number: z.string(),
    countryCodeEnum: z.string(),
  }),
  country: z.string().optional(),
});

export type ClientSchemaType = z.infer<typeof clientSchema>;